export const types = {
  TODO_FETCH: 'TODO_FETCH',
  TODO_FETCH_SUCCESS: 'TODO_FETCH_SUCCESS',
  TODO_FETCH_ERROR: 'TODO_FETCH_ERROR',
  TODO_ADD: 'TODO_ADD',
  TODO_REMOVE: 'TODO_REMOVE',
  TODO_CLEAR: 'TODO_CLEAR'
};